import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Pricing.css';

const pricingTiers = [
  {
    tier: 'Starter',
    price: 'Free Access',
    users: 'Single admin',
    features: ['Everything You Need', "Nothing you don't"],
    badge: 'Popular',
    claim:'Start Free Trial',
    clickable: true,
  },
  // Uncomment additional tiers when ready
  {
    tier: 'Growth',
    // price: '₹2,999/month',
    users: 'Upto 50 team members',
    features: ['All Starter features', 'Team collaboration', 'Project milestones'],
    claim:'Coming Soon',
    clickable: false,
  },
  {
    tier: 'Pro',
    // price: '₹6,999/month',
    users: 'Above 50 team members',
    features: ['All Growth features', 'Advanced reporting', 'Priority support'],
    claim:'Coming Soon',
    clickable: false,
  },
  {
    tier: 'Enterprise',
    price: 'Custom pricing',
    users: 'Large organizations',
    features: ['Custom solution & integrations', 'Dedicated support'],
    claim:'Coming Soon',
    clickable: false,
  },
];

function Pricing() {
  const navigate = useNavigate();

  const handleButtonClick = (tier) => {
    if (tier.clickable) {
      navigate('/login');
    }
  };

  return (
    <section id="pricing" className="pricing-section container">
      <h2 className="pricing-title">Simple, Transparent Pricing That Grows With You</h2>
      <p className="pricing-subtext">
        Start lean, scale smart. Upgrade anytime no setup fees or hidden charges.
      </p>

      <div className="pricing-grid">
        {pricingTiers.map((tier, i) => (
          <div key={i} className={`price-card ${i === 0 ? 'highlight' : ''}`}>
            {tier.badge && <span className="badge">{tier.badge}</span>}

            <h3 className="plan-name">{tier.tier}</h3>

            <div className="price-wrap">
              <span className="price">{tier.price}</span>
              <span className="users">{tier.users}</span>
            </div>

            <ul className="features">
              {tier.features.map((f, idx) => (
                <li key={idx} className="feature-item">
                  <span className="check">✓</span>
                  <span>{f}</span>
                </li>
              ))}
            </ul>

            <button 
              className={`primary-btn ${!tier.clickable ? 'disabled' : ''}`}
              onClick={() => handleButtonClick(tier)}
              disabled={!tier.clickable}
            >
              {tier.claim}
            </button>
            {/* <p className="tiny-note">No credit card required</p> */}
          </div>
        ))}
      </div>
    </section>
  );
}

export default Pricing;